<template>
  <div class="row">
    <div class="col-md-6">
      <h6>{{ label }}</h6>
      <h4 class="mb-4">{{ title }}</h4>
      <slot />
      <div class="d-flex justify-content-between">
        <radial-progress
          :diameter="55"
          :completed-steps="completedSteps ? completedSteps : progressPercents"
          :total-steps="completedSteps ? totalSteps : 100"
          :stroke-width="5"
          :inner-stroke-width="5"
        >
          <small v-if="progressPercents >= 0" class="text-bold"> {{ progressPercents }}% </small>
          <small v-else class="text-bold">{{ completedSteps }}/{{ totalSteps }}</small>
        </radial-progress>

        <b-button
          variant="link"
          v-if="buttonLinkText"
          size="sm"
          @click="$emit('onViewStreamClick')"
        >
          {{ buttonLinkText }}
        </b-button>
      </div>
    </div>
    <div class="col-md-6 d-flex px-5 image-container justify-content-center">
      <b-img :src="imgSrc" />
    </div>
  </div>
</template>

<script>
import RadialProgress from "./RadialProgress";

export default {
  name: "NextLearningUnit",
  components: {
    RadialProgress,
  },
  props: {
    title: String,
    label: String,
    imgSrc: String,
    buttonLinkText: String,
    totalSteps: Number,
    completedSteps: Number,
    progressPercents: Number,
  },
};
</script>

<style scoped lang="scss">
.image-container {
  max-height: 350px;

  img {
    max-height: 100%;
    width: auto;
  }
}
</style>
